// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__s3GIu","inverted":"Select_inverted__x2K1V","medium":"Select_medium__bp1o5","select_small":"Select_select_small__5QhCx","icon":"Select_icon__utzJV"};